import { jsx as _jsx } from "react/jsx-runtime";
import { reportErrorToBugsnag } from "@air/utils-error";
import noop from "lodash/noop";
import { createContext, memo, useContext, useState } from "react";
import { useAssetHotkeys } from "~/components/AssetModal/Visualizer/shared/useAssetHotkeys";
import { MAX_ZOOM, MIN_ZOOM } from "~/components/AssetModalV2/Visualizer/ImageVisualizer/shared/constants";
import { isDevOrTestStage } from "~/swr-hooks/utils";
const ZOOM_INCREMENT = 0.5;
const IMAGE_CONTENT_CONTROLS_CONTEXT_DEFAULT_VALUE = {
    showOriginal: false,
    setShowOriginal: noop,
    zoom: 1,
    onZoomIn: noop,
    onZoomOut: noop
};
export const ImageContentControlsContext = /*#__PURE__*/ createContext(IMAGE_CONTENT_CONTROLS_CONTEXT_DEFAULT_VALUE);
export const ImageContentControlsContextProvider = /*#__PURE__*/ memo((param)=>{
    let { children } = param;
    const [showOriginal, setShowOriginal] = useState(false);
    const [zoom, setZoom] = useState(1);
    const onZoomIn = ()=>{
        setZoom((prev)=>{
            const newZoom = prev + ZOOM_INCREMENT < MAX_ZOOM ? prev + ZOOM_INCREMENT : MAX_ZOOM;
            return newZoom;
        });
    };
    const onZoomOut = ()=>{
        setZoom((prev)=>{
            const newZoom = prev - ZOOM_INCREMENT > MIN_ZOOM ? prev - ZOOM_INCREMENT : MIN_ZOOM;
            return newZoom;
        });
    };
    // Use the asset hotkeys hook
    useAssetHotkeys({
        zoomIn: onZoomIn,
        zoomOut: onZoomOut
    });
    return /*#__PURE__*/ _jsx(ImageContentControlsContext.Provider, {
        value: {
            showOriginal,
            setShowOriginal,
            zoom,
            onZoomIn,
            onZoomOut
        },
        children: children
    });
});
ImageContentControlsContextProvider.displayName = "ImageContentControlsContextProvider";
export const useImageContentControlsContext = ()=>{
    const context = useContext(ImageContentControlsContext);
    if (context === IMAGE_CONTENT_CONTROLS_CONTEXT_DEFAULT_VALUE) {
        const error = new Error("useImageContentControlsContext must be used within a ImageContentControlsContextProvider");
        if (isDevOrTestStage()) {
            throw error;
        } else {
            reportErrorToBugsnag({
                error,
                context: "ImageContentControlsContext not found"
            });
        }
    }
    return context;
};
